import api from '../../api'

// initial state
const state = {
  data: null,
  allBills: null,
  serviceBills: null,
  shoppingBills: null,
  deliveryBills: null,
  subscriptionBills: null
}

// getters
const getters = {
  getDataByFilter: state => filter => {
    switch (filter) {
      case 'allBills':
        return state.allBills
      case 'serviceBills':
        return state.serviceBills
      case 'shoppingBills':
        return state.shoppingBills
      case 'deliveryBills':
        return state.deliveryBills
      case 'subscriptionBills':
        return state.subscriptionBills
      default:
        return state.data
    }
  }
}

// actions
const actions = {
  loadData({ state, dispatch, getters }, filter) {
    let data = getters['getDataByFilter'](filter)
    if (!data) {
      dispatch('refreshData', filter)
    }
  },
  refreshData({ state, commit, rootState }, filter) {
    api.get('charts/' + filter, data => {
      commit('setData', { data: data, filter: filter })
    })
  }
}

// mutations
const mutations = {
  setData(state, payload) {
    switch (payload.filter) {
      case 'allBills':
        state.allBills = payload.data
        break
      case 'serviceBills':
        state.serviceBills = payload.data
        break
      case 'shoppingBills':
        state.shoppingBills = payload.data
        break
      case 'deliveryBills':
        state.deliveryBills = payload.data
        break
      case 'subscriptionBills':
        state.subscriptionBills = payload.data
        break
      default:
        state.data = payload.data
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/charts.js